import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient();

export const getRequestState = (queryKey: any, queryFilters?: any) => {
  return queryClient.getQueryState(queryKey, queryFilters);
};

export const getState = (queryKey: any, queryFilters?: any) => {
  return queryClient.getQueryData([queryKey], queryFilters);
};

export const clearCache = () => {
  return queryClient.clear();
};

export default queryClient;
